// Mapbox Geocoding v6 helpers. Results are returned in the provider-neutral
// place shape used by all map components: { place_id, formatted_address, lat, lng }.
// fetch() is used instead of axios so the app's Authorization header and
// cookies are never sent to Mapbox.
// permanent=true is always sent: Mapbox only allows storing geocoding results
// (stop and school addresses are stored) with permanent geocoding.
const GEOCODING_URL = "https://api.mapbox.com/search/geocode/v6/";

function toPlace(feature) {
  const props = feature.properties || {};
  const [lng, lat] = feature.geometry.coordinates;
  return {
    place_id: props.mapbox_id,
    formatted_address: props.full_address || props.place_formatted || props.name,
    name: props.name,
    lat: lat,
    lng: lng,
  };
}

function request(endpoint, params, config) {
  const query = new URLSearchParams(
    Object.assign({ access_token: config.mapboxToken, permanent: "true" }, params)
  );
  return fetch(GEOCODING_URL + endpoint + "?" + query.toString())
    .then((response) => {
      if (!response.ok) {
        throw new Error("Mapbox geocoding failed: " + response.status);
      }
      return response.json();
    })
    .then((data) => (data.features || []).map(toPlace));
}

export function forwardGeocode(text, config, proximity = null) {
  const params = { q: text, limit: 5, autocomplete: "true" };
  if (proximity && !isNaN(proximity.lat) && !isNaN(proximity.lng)) {
    params.proximity = proximity.lng + "," + proximity.lat;
  }
  return request("forward", params, config);
}

export function reverseGeocode(lat, lng, config) {
  // features come back most specific first (address, street, place, ...)
  return request("reverse", { latitude: lat, longitude: lng }, config).then(
    (places) => places[0] || null
  );
}
